"use client"

import type React from "react"

import { FormData } from "./types"
import { Input } from "@/shared/components/atoms/Input"
import { Card } from "../ui/card-animated"

interface AddressInfoSectionProps {
  formData: FormData
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void
}

export const AddressInfoSection: React.FC<AddressInfoSectionProps> = ({ formData, handleChange }) => {
  return (
    <Card title="Información de Dirección" delay={1}>
      <div className="space-y-4">
        <Input label="Dirección" name="address" value={formData.address} onChange={handleChange} required />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input label="País" name="country" value={formData.country} onChange={handleChange} required />
          <Input label="Estado/Provincia" name="state" value={formData.state} onChange={handleChange} required />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input label="Ciudad" name="city" value={formData.city} onChange={handleChange} required />
          <Input
            label="Código Postal"
            name="postal_code"
            value={formData.postal_code}
            onChange={handleChange}
            required
          />
        </div>
      </div>
    </Card>
  )
}
